import styled from 'styled-components';
import { StyledButton as Button } from '../../../../../../../CommonComponents/Button';

export const LinkButton = styled(Button.Link)`
  font-size: 14px;
  color: #5abee4;
  font-weight: 600;
`;

export const StyledDetails = styled.div`
  margin-top: 16px;
`;

export const DetailsWrapper = styled.div`
  font-size: 14px;
  color: #333;
  margin-top: 16px;
`;
